import { useEffect, useState } from "react";

const AdminContestPage = () => {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  // =========================
  // FETCH PARTICIPANTS
  // =========================
  const fetchParticipants = async () => {
    try {
      const res = await fetch(
        "https://creator-mvp-hvdx.onrender.com/admin/contest/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();

      setParticipants(data);

    } catch (err) {

      console.error(
        "Error loading participants",
        err
      );

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    fetchParticipants();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =========================
  // APPROVE USER
  // =========================
  const approveUser = async (userId) => {

    await fetch(
      `https://creator-mvp-hvdx.onrender.com/admin/contest/approve/${userId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    fetchParticipants();
  };

  // =========================
  // REJECT USER
  // =========================
  const rejectUser = async (userId) => {

    await fetch(
      `https://creator-mvp-hvdx.onrender.com/admin/contest/reject/${userId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    fetchParticipants();
  };

  // =========================
  // APPROVE TASK
  // =========================
  const approveTask = async (
    userId,
    taskName
  ) => {

    try {

      await fetch(
        `https://creator-mvp-hvdx.onrender.com/admin/contest/approve-task/${userId}/${taskName}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchParticipants();

    } catch (err) {

      console.error(
        "Error approving task",
        err
      );

    }
  };

  // =========================
  // TASK CHIP UI
  // =========================
  const TaskChip = ({
    completed,
    label,
    onClick,
  }) => {

    return (
      <button
        onClick={onClick}
        disabled={completed}
        style={{
          border: "none",
          padding: "8px 12px",
          borderRadius: 999,
          cursor: completed
            ? "default"
            : "pointer",
          fontWeight: "bold",
          fontSize: 12,
          background: completed
            ? "#22c55e"
            : "#f3f4f6",
          color: completed
            ? "#fff"
            : "#111827",
          transition: "0.2s",
        }}
      >
        {completed ? "✅" : "⬜"} {label}
      </button>
    );
  };

  // =========================
  // LOADING
  // =========================
  if (loading) {

    return (
      <h2>
        Loading admin contest panel... ⏳
      </h2>
    );
  }

  return (
    <div className="container">

      <h2
        style={{
          marginBottom: 20,
        }}
      >
        🧑‍💼 Admin Contest Panel
      </h2>

      <div
        className="card"
        style={{
          overflowX: "auto",
        }}
      >

        <table
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: 1200,
          }}
        >

          <thead>

            <tr
              style={{
                background: "#f9fafb",
              }}
            >

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                User
              </th>

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                Status
              </th>

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                Points
              </th>

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                Support
              </th>

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                Joined
              </th>

              <th
                style={{
                  padding: 14,
                  textAlign: "left",
                }}
              >
                Tasks & Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {participants.map((p) => (

              <tr
                key={p.id}
                style={{
                  borderBottom:
                    "1px solid #f3f4f6",
                }}
              >

                {/* USER */}
                <td
                  style={{
                    padding: 16,
                    fontWeight: "bold",
                  }}
                >
                  👤 #{p.user_id}
                </td>

                {/* STATUS */}
                <td
                  style={{
                    padding: 16,
                  }}
                >

                  <span
                    style={{
                      background:
                        p.contest_status ===
                        "approved"
                          ? "#dcfce7"
                          : "#fee2e2",

                      color:
                        p.contest_status ===
                        "approved"
                          ? "#166534"
                          : "#991b1b",

                      padding: "6px 12px",

                      borderRadius: 999,

                      fontSize: 12,

                      fontWeight: "bold",
                    }}
                  >
                    {p.contest_status}
                  </span>

                </td>

                {/* POINTS */}
                <td
                  style={{
                    padding: 16,
                    fontWeight: "bold",
                  }}
                >
                  ⭐ {p.total_points}
                </td>

                {/* SUPPORT */}
                <td
                  style={{
                    padding: 16,
                    fontWeight: "bold",
                    color: "#16a34a",
                  }}
                >
                  ₦{p.total_support_received}
                </td>

                {/* JOINED */}
                <td
                  style={{
                    padding: 16,
                    fontSize: 13,
                    opacity: 0.7,
                  }}
                >
                  {new Date(
                    p.joined_at
                  ).toLocaleString()}
                </td>

                {/* ACTIONS */}
                <td
                  style={{
                    padding: 16,
                  }}
                >

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      minWidth: 320,
                    }}
                  >

                    {/* APPROVE */}
                    <button
                      onClick={() =>
                        approveUser(p.user_id)
                      }
                      style={{
                        background: "#22c55e",
                        color: "#fff",
                        border: "none",
                        padding: "8px 14px",
                        borderRadius: 10,
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      Approve
                    </button>

                    {/* REJECT */}
                    <button
                      onClick={() =>
                        rejectUser(p.user_id)
                      }
                      style={{
                        background: "#ef4444",
                        color: "#fff",
                        border: "none",
                        padding: "8px 14px",
                        borderRadius: 10,
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      Reject
                    </button>

                    {/* TASKS */}
                    <TaskChip
                      label="Photo"
                      completed={
                        p.task_photo_posted
                      }
                      onClick={() =>
                        approveTask(
                          p.user_id,
                          "task_photo_posted"
                        )
                      }
                    />

                    <TaskChip
                      label="Asset"
                      completed={
                        p.task_asset_created
                      }
                      onClick={() =>
                        approveTask(
                          p.user_id,
                          "task_asset_created"
                        )
                      }
                    />

                    <TaskChip
                      label="Link"
                      completed={
                        p.task_support_link_added
                      }
                      onClick={() =>
                        approveTask(
                          p.user_id,
                          "task_support_link_added"
                        )
                      }
                    />

                    <TaskChip
                      label="Support"
                      completed={
                        p.task_received_support
                      }
                      onClick={() =>
                        approveTask(
                          p.user_id,
                          "task_received_support"
                        )
                      }
                    />

                    <TaskChip
                      label="Video"
                      completed={
                        p.task_video_created
                      }
                      onClick={() =>
                        approveTask(
                          p.user_id,
                          "task_video_created"
                        )
                      }
                    />

                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AdminContestPage;